// The CSV template for brokers we don't read directly: download it, fill it in, import it.
export const TEMPLATE_CSV =
  'symbol,side,size,entryPrice,exitPrice,pnl,fees,date,notes\n' +
  'MNQZ6,Long,2,21450.25,21470.75,82.00,2.80,2026-10-01,Pullback to VWAP\n' +
  'ESZ6,Short,1,7790.25,7787.50,137.50,2.78,2026-10-16,Fade at prior high\n';
export const TEMPLATE_HREF = `data:text/csv;charset=utf-8,${encodeURIComponent(TEMPLATE_CSV)}`;
